import React from 'react';
export function Footer() {
  return <footer className="bg-brand-navy text-gray-400 py-12 px-4 border-t border-gray-800" data-id="element-70">
      <div className="max-w-5xl mx-auto text-center" data-id="element-71">
        <p className="text-xs md:text-sm leading-relaxed max-w-4xl mx-auto opacity-70" data-id="element-72">
          Este producto es educativo e informativo. No reemplaza la consulta con
          un veterinario ni constituye asesoramiento médico veterinario. Cada
          perro puede tener necesidades distintas según su edad, peso, raza,
          salud, alergias y nivel de actividad. Consulta siempre con un
          profesional veterinario antes de hacer cambios significativos en la
          alimentación de tu mascota.
        </p>
        <div className="mt-8 pt-8 border-t border-gray-800 text-xs opacity-50" data-id="element-73">
          &copy; {new Date().getFullYear()} Pack Recetas Caseras Saludables para
          Perros. Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}